import { useQuery } from "@apollo/react-hooks";
import { httpClient } from "../settings/apolloClient";
import { GET_APP_CONFIG_QUERY } from "../graphql/appConfigQueries";

const DEFAULTS = {
  volumeDefault: 5,
  volumeMax: 12,
  volumeStep: 0.5,
};

export function useAppConfig() {
  const { data } = useQuery(GET_APP_CONFIG_QUERY, {
    client: httpClient,
    fetchPolicy: "cache-first",
  });

  const appConfig = data && data.appConfig;
  return {
    volumeDefault: (appConfig && appConfig.volumeDefault) || DEFAULTS.volumeDefault,
    volumeMax: (appConfig && appConfig.volumeMax) || DEFAULTS.volumeMax,
    volumeStep: (appConfig && appConfig.volumeStep) || DEFAULTS.volumeStep,
  };
}
